export const REPLY = 'reply';
export const REPLY_ALL = 'replyAll';
export const FORWARD = 'forward';